const ROOM_LISTING_BASE = "/listing";

export const newRoomListingEndpoints = {
  getListings: `${ROOM_LISTING_BASE}`,
  getListingsCoords: `${ROOM_LISTING_BASE}/coords`,
  create: `${ROOM_LISTING_BASE}/add`,
  getForUser: (userId: string) => `${ROOM_LISTING_BASE}/user/${userId}`,
  byId: (listingId: string) => `${ROOM_LISTING_BASE}/${listingId}`,
  matchesById: (listingId: string) =>
    `${ROOM_LISTING_BASE}/${listingId}/matches`,
  matchAlerts: (listingId: string) =>
    `${ROOM_LISTING_BASE}/${listingId}/match-alerts`,
  matchAlertsUnsubscribe: (listingId: string) =>
    `${ROOM_LISTING_BASE}/${listingId}/match-alerts/unsubscribe`,
  myAlerts: `${ROOM_LISTING_BASE}/my/alerts`,
  viewsTimeseries: (listingId: string) =>
    `${ROOM_LISTING_BASE}/${listingId}/views-timeseries`,
  history: (listingId: string) => `${ROOM_LISTING_BASE}/${listingId}/history`,
  zonePrice: (listingId: string) =>
    `${ROOM_LISTING_BASE}/${listingId}/zone-price`,
  zonePriceDistribution: (listingId: string) =>
    `${ROOM_LISTING_BASE}/${listingId}/zone-price/distribution`,
  updateListingPublishStatus: (listingId: string) =>
    `${ROOM_LISTING_BASE}/${listingId}/publish-status`,
  updateListingResourceId: (listingId: string | null) =>
    `${ROOM_LISTING_BASE}/${listingId}/resource`,
  updateListingImagesByIf: (listingId: string | null) =>
    `${ROOM_LISTING_BASE}/${listingId}/images`,
  getListingDocuments: (listingId: string) =>
    `${ROOM_LISTING_BASE}/${listingId}/documents`,
  uploadListingDocument: (listingId: string) =>
    `${ROOM_LISTING_BASE}/${listingId}/documents`,
  deleteListingDocument: (listingId: string, documentId: string) =>
    `${ROOM_LISTING_BASE}/${listingId}/documents/${documentId}`,
};
